export default "__VITE_ASSET__U4u$dAE0__"